import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { OverChargeClaim, OverChargeClaimPrintFormInfo } from '../../types';

export interface GetOCClaimPrintFormRequestParams {
  FBOCKey: OverChargeClaim['fbocKey'];
}

export const getOverChargeClaimPrintDetailsAPI = (params: GetOCClaimPrintFormRequestParams) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetPrintForm`,
    method: 'get',
    params,
  });
};

export type OCClaimPrintFormResponse = OverChargeClaimPrintFormInfo;

export const fetchOCClaimPrintForm = async (
  params: GetOCClaimPrintFormRequestParams,
): Promise<OCClaimPrintFormResponse> => {
  const response: AxiosResponse<OCClaimPrintFormResponse> = await getOverChargeClaimPrintDetailsAPI(params);
  return response.data;
};
